var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"color":"accent","loading":_vm.loading,"icon":"mdi-receipt"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t('invoice_pdf'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }